<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Next from '~/assets/images/next.svg?component'

const user = useFirebaseUser()
</script>

<template>
  <footer class="mt-16">
    <hr class="grow border-blurple-500 dark:border-gray-700 relative">
    <div class="mx-auto w-full max-w-screen-xl px-4 py-10 md:p-12">
      <div
        v-if="!user || user?.isAnonymous"
        class="mb-12"
      >
        <LayoutDefaultNewsletterSignup footer />
      </div>
      <div
        v-else
        class="max-w-[600px] mb-12"
      >
        <h3 class="h3">
          {{ $t('passionEquipExistsTo') }}
        </h3>
        <div class="flex mt-4 p-md items-center">
          {{ $t('learnMoreMovement') }}
          <PLink
            id="learn-more-movement"
            href="https://passioncitychurch.com/us/"
            class="ms-4 bg-blurple-600 py-1 px-3 rounded-lg"
          >
            <Next class="w-6 h-6 fill-white" />
          </PLink>
        </div>
      </div>
      <div class="flex flex-wrap gap-x-4 mt-4">
        <PLink
          id="footer-pcc"
          href="https://passioncitychurch.com/"
          class="p-sm text-black underline"
        >
          {{ $t('passionCityChurch') }}
        </PLink>
        <PLink
          id="footer-pc"
          href="https://passionconferences.com/"
          class="p-sm text-black underline"
        >
          {{ $t('passionConferences') }}
        </PLink>
        <PLink
          id="footer-pp"
          href="https://passionpublishing.com/"
          class="p-sm text-black underline"
        >
          {{ $t('passionPublishing') }}
        </PLink>
        <PLink
          id="footer-pr"
          href="https://passionresources.com/"
          class="p-sm text-black underline"
        >
          {{ $t('passionResources') }}
        </PLink>
        <PLink
          id="footer-ssr"
          href="https://sixstepsrecords.com/"
          class="p-sm text-black underline"
        >
          {{ $t('sixsteprecords') }}
        </PLink>
      </div>
      <div class="p-sm text-black mt-4 uppercase font-sans">
        &copy; 2024
        <PLink
          id="footer-home-copyright"
          href="/"
          class="p-sm text-black font-sans"
        >
          {{ $t('passionEquip') }}
        </PLink>. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>
